"use client";
import { useEffect } from "react";
import { logError } from "@jetblue/dotcom-fe-logger";
import {
  registerConsentChangeListener,
  resolveConsentDecision,
  setTrustedConsentOrigin,
} from "./consent";

export const TrustArcClient = ({
  trustArcOrigin,
}: {
  trustArcOrigin: string;
}) => {
  useEffect(() => {
    setTrustedConsentOrigin(trustArcOrigin);
    registerConsentChangeListener();

    resolveConsentDecision().catch((error: unknown) => {
      void logError({
        error,
        message: "Failed to resolve TrustArc consent decision",
      });
    });
  }, [trustArcOrigin]);

  return null;
};
